import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@/components/Table/Table';
import { type ActivityLogRow } from '@/features/reports/api';
import { HEATMAP_COPY } from '@/features/reports/copy';
import { formatWhen } from '@/lib/format';

const COPY = HEATMAP_COPY.log;

/**
 * The activity log's rows (ALS-88), the flat log the old portal exported: who, where in the app,
 * what they did, what it was, and the colour when the app sent one.
 */
export function ActivityTable({ rows }: { rows: ActivityLogRow[] }) {
    const columns = COPY.columns;
    return (
        // Seven columns do not fit a phone, so below 768 each row becomes a card: the client
        // leads, and the rest each get a labelled line rather than sitting behind a sideways swipe.
        <Table stack className="table-stack--wide-labels">
            <TableHeader>
                <TableRow>
                    <TableHead>{columns.client}</TableHead>
                    <TableHead>{columns.module}</TableHead>
                    <TableHead>{columns.area}</TableHead>
                    <TableHead>{columns.action}</TableHead>
                    <TableHead>{columns.reference}</TableHead>
                    <TableHead>{columns.context}</TableHead>
                    <TableHead>{columns.viewedOn}</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.id}>
                        <TableCell data-stack="title" className="font-medium md:whitespace-nowrap">
                            {row.client}
                        </TableCell>
                        <TableCell data-stack="meta" data-label={columns.module}>
                            {row.module}
                        </TableCell>
                        <TableCell data-stack="meta" data-label={columns.area}>
                            {row.area}
                        </TableCell>
                        <TableCell data-stack="meta" data-label={columns.action}>
                            {row.action}
                        </TableCell>
                        <TableCell
                            data-stack="meta"
                            data-label={columns.reference}
                            className="break-words"
                        >
                            {row.reference ?? ''}
                        </TableCell>
                        <TableCell data-stack="meta" data-label={columns.context}>
                            {row.context ?? <span className="sr-only">{COPY.none}</span>}
                        </TableCell>
                        <TableCell
                            data-stack="meta"
                            data-label={columns.viewedOn}
                            className="text-muted-foreground md:whitespace-nowrap"
                        >
                            {formatWhen(row.viewedOn)}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
